<div class="account-block">
  @if (isExpanded) {
    <h3 class="username">{{userName | async}}</h3>
  }
  <a class="logout-link" (click)="logout()" matTooltip="Logout">
    <mat-icon>exit_to_application</mat-icon>
  </a>
</div>
